/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Link, useLocation } from "react-router-dom"
import { getCurrentUser, getBaseUrl } from "../reducers"
import BackendHeader from "./Backend/BackendHeader"
import { getAssetPath } from "../utils/assets"
import { liveLifeDashboardPath } from "./Dashboard/LiveLife/constants"

function Header({ currentUser }) {
  const { pathname } = useLocation()

  useEffect(() => {
    let newClass = "user"
    const oldClass = document.body.className
    if (["/login", "/signup"].includes(pathname)) {
      newClass = "session"
    } else if (pathname.includes("survey") || pathname.includes("pulse-check/") || pathname.includes("mental-skills/") || pathname.includes("matchfit/") || pathname.includes("burnout-proof/") || pathname.includes("livelife/")) {
      newClass = "survey"
    } else if (pathname.includes("backend")) {
      newClass = "backend"
      if (currentUser?.role !== "admin") {
        window.location.href = "/"
      }
    }
    document.body.className = newClass
    if (oldClass !== newClass) {
      window.location.reload()
    }
  }, [pathname, currentUser?.role])

  if (window.location.pathname === "/verify-email") {
    return (
      <div className="navbar navbar-light bg-white">
        <Link
          className="navbar-brand"
          to="#">
          <img src={getAssetPath("logo")} className="ss-logo" alt="Strive Stronger Logo" />
        </Link>
      </div>
    )
  }

  if (window.location.pathname !== "/verify-email" && currentUser && !currentUser?.confirmed_at) {
    window.location.href = "/verify-email"
  }

  // const currentPage = ["", "overview", "settings", "enrol"].includes(pathname.split("/")[1]) ? "overview" : "10DWC"
  let currentPage = "overview"
  if (pathname.includes("ten-dwc")) {
    currentPage = "10DWC"
  } else if (pathname.includes("pulse-check")) {
    currentPage = "Pulse Check"
  } else if (pathname.includes("mental-skills")) {
    currentPage = "Mental Skills"
  } else if (pathname.includes("burnout-proof")) {
    currentPage = "Burnout Proof"
  } else if (pathname.includes("matchfit")) {
    // Not sure if this will break something else
    // } else if (pathname.includes("matchfit/")) {
    currentPage = "Matchfit"
  } else if (pathname.includes("livelife")) {
    currentPage = String(currentUser?.active_enrolment?.live_life_version) === "2" ? "PQ Index" : "LiveLife Score"
  }

  if (["/login", "/signup"].includes(pathname)) {
    return null
  }
  if (pathname.includes("survey") || pathname.includes("pulse-check/") || pathname.includes("mental-skills/") || pathname.includes("matchfit/") || pathname.includes("burnout-proof/") || pathname.includes("livelife/")) {
    return null
  }
  if (pathname.includes("backend")) {
    return <BackendHeader currentUser={currentUser} />
  }

  document.getElementById("react-app").style.display = "flex"
  document.getElementById("react-app").style.flexDirection = "column"
  return (
    <div className="navbar navbar-light bg-white">
      <Link
        className="navbar-brand"
        to="/">
        <img src={getAssetPath("logo")} className="ss-logo" alt="Strive Stronger Logo" />
      </Link>
      {currentUser?.firstname && (
        <>
          <div className="calc-toggle-container">
            <div className="dropdown calc-toggle">
              <a
                aria-expanded="true"
                aria-haspopup="true"
                className="nav-link dropdown-toggle"
                data-toggle="dropdown"
                href="#"
                id="navbarDropdown"
                role="button">
                <span>{currentPage}</span>
              </a>
              <div aria-labelledby="navbarDropdown" className="dropdown-menu dropdown-menu-right">
                <Link
                  className="dropdown-item"
                  to="/overview">
                  Overview
                </Link>
                {currentUser?.active_ten_dwc_id && (
                  <Link
                    className="dropdown-item"
                    to="/ten-dwc-dashboard">
                    10DWC
                  </Link>
                )}
                {currentUser?.active_pulse_id && (
                  <Link
                    className="dropdown-item"
                    to="/pulse-check-dashboard">
                    Pulse Check
                  </Link>
                )}
                {currentUser?.active_mental_skills_id && (
                  <Link
                    className="dropdown-item"
                    to="/mental-skills-dashboard">
                    Mental Skills
                  </Link>
                )}
                {currentUser?.active_matchfit_id && (
                  <Link
                    className="dropdown-item"
                    to="/matchfit-dashboard">
                    MatchFit
                  </Link>
                )}
                {currentUser?.active_burnout_proof_id && (
                  <Link
                    className="dropdown-item"
                    to="/burnout-proof-dashboard">
                    Burnout Proof
                  </Link>
                )}
                {currentUser?.active_live_life_id && (
                  <Link
                    className="dropdown-item"
                    to={liveLifeDashboardPath(currentUser?.active_enrolment?.live_life_version)}>
                    {String(currentUser?.active_enrolment?.live_life_version) === "2" ? "PQ Index" : "LiveLife Score"}
                  </Link>
                )}
              </div>
            </div>
          </div>

          <div className="dropdown">
            <a
              aria-expanded="false"
              aria-haspopup="true"
              className="nav-link dropdown-toggle"
              data-toggle="dropdown"
              href="#"
              id="navbarDropdown"
              role="button">
              <span>{currentUser.firstname}</span>
            </a>
            <div aria-labelledby="navbarDropdown" className="dropdown-menu dropdown-menu-right">
              <Link
                className="dropdown-item"
                to="/">
                Home
              </Link>
              <Link
                className="dropdown-item"
                to="/settings">
                Settings
              </Link>
              <Link
                className="dropdown-item"
                to="/enrol">
                Enrol
              </Link>
              <a className="dropdown-item" href="https://performanceintelligence.com/terms-of-use">Terms of Use</a>
              <a className="dropdown-item" href="https://performanceintelligence.com/privacy-policy"> Privacy Policy</a>
              {currentUser?.role === "admin" && (
                <>
                  <div className="dropdown-divider"></div>
                  <Link
                    className="dropdown-item"
                    to="/backend">
                    Admin View
                  </Link>
                </>
              )}
              <div className="dropdown-divider"></div>
              <Link
                className="dropdown-item"
                to="/logout"
                onClick={() => { window.location.href = "/logout" }}>
                Log out
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  currentUser: getCurrentUser(state),
  baseUrl: getBaseUrl(state)
})

export default connect(mapStateToProps)(Header)